export const updateObject = (oldObject, updatedProperties) => ({
    ...oldObject,
    ...updatedProperties
  });
  